import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-compiled-statewise-report',
  templateUrl: './compiled-statewise-report.component.html',
  styleUrls: ['./compiled-statewise-report.component.scss']
})
export class CompiledStatewiseReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
